import { Button, Divider } from "antd";
import arrowLeft from "./../../assets/images/arrow-left.svg";
import meditation from "./../../assets/images/meditation.webp";
import stepsBg from "./../../assets/images/steps-bg.png";
import benefits from "./../../assets/images/benefits.webp";
import { useNavigate } from "react-router-dom";
import useStore from "../../store/useStore";

const KnowMore = () => {
  const navigate = useNavigate();
  const { doctorDetails } = useStore((state) => ({
    doctorDetails: state.doctorDetails,
  }));
  const commission = doctorDetails?.user?.commission || 0;
  const backBtnHandler = () => {
    navigate("/remote-care");
  };
  const referBtnHandler = () => {
    navigate("/patient-condition");
  };

  const stepsDetails = [
    {
      title: "Refer a Care Plan",
      description:
        "Select a suitable care plan for your patient from our list of personalised options.",
    },
    {
      title: "Send the Referral",
      description: "Share the care plan link with your patient via WhatsApp.",
    },
    {
      title: "Earn Rewards",
      description: `You’ll get ${commission}% of the value of each care plan purchased by the patients.`,
    },
    {
      title: "Track Progress",
      description:
        "Monitor your patients health logs and progress directly in the app.",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      {/* Fixed Header */}
      <div className="fixed top-0 left-0 z-10 w-full bg-[#EBEBFF]">
        <div className="flex items-center text-lg font-semibold gap-2 p-6">
          <img
            className="cursor-pointer"
            height={22}
            width={22}
            src={arrowLeft}
            alt="arrow-left"
            onClick={backBtnHandler}
          />
          <span>Back</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 bg-[#F9F9FF] pb-10 pt-[76px]">
        <img src={meditation} alt="meditation" />
        <div className="px-6 py-14">
          <div className="text-2xl text-left font-semibold pb-8">
            Step by Step Guide
          </div>
          <div className="flex flex-col gap-y-4">
            {stepsDetails.map((item: any, index: number) => {
              return (
                <div key={index} className="flex gap-x-6">
                  <div className="flex flex-col items-center gap-y-3">
                    <span
                      className="font-manrope bg-no-repeat bg-center h-[66px] w-[66px] flex flex-col items-center justify-center text-[#fff] text-3xl font-extrabold"
                      style={{
                        backgroundImage: `url(${stepsBg})`,
                        backgroundSize: "contain",
                      }}
                    >
                      {index + 1}
                    </span>
                    {index !== 3 && (
                      <Divider
                        type="vertical"
                        style={{
                          borderLeftColor: "#BA7DE9",
                          borderLeftWidth: "2px",
                          borderLeftStyle: "dashed",
                          height: "55px",
                        }}
                      />
                    )}
                  </div>
                  <div className="flex flex-col text-left gap-y-1 pr-8">
                    <div className="text-xl font-semibold">{item.title}</div>
                    <span>{item.description}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <img className="pl-6" src={benefits} alt="meditation" />
      </div>

      {/* Footer with Button */}
      <div className="px-6 pt-4 pb-8">
        {/* <Button
          type="primary"
          className="w-full h-14 rounded-2xl bg-[#4B4AD5] p-5 text-lg font-medium"
          onClick={referBtnHandler}
        >
          Refer Care Plan Now
        </Button> */}
      </div>
    </div>
  );
};

export default KnowMore;
